module.exports = __webpack_public_path__ + "img/phone.e1514bb8.svg";